<div class="page-title-area">
    <img src="assets/images/it_strategy_banner.png" alt="Page Background" class="page-bg">
    <button class="back-arrow-btn" (click)="navigateToHome()">
        <i class="fas fa-chevron-left fa-2x"></i>
    </button>
    <div class="container">
        <div class="page-title-content">
            <h2>Resources for your IT Strategy</h2>
        </div>
    </div>

</div>

<section class="animated-cards-section ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="innovation-image">
                    <div class="circular-image-container">
                        <img src="assets/images/it_strtegy_12.png" alt="Apple Innovation" class="circular-image">
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="innovation-content">
                    <h2 class="slide-in" data-delay="0">Resources for your IT Strategy</h2>
                    <div class="feature-list">
                        <div class="feature-item slide-in" data-delay="200">
                            <i class="fas fa-laptop-code"></i>
                            <p>Apple-Innovative custom architected solutions for efficient device management</p>
                        </div>
                        <div class="feature-item slide-in" data-delay="400">
                            <i class="fas fa-shield-alt"></i>
                            <p>Zero-touch deployment with Apple Business Manager and secure MDM frameworks</p>
                        </div>
                        <div class="feature-item slide-in" data-delay="600">
                            <i class="fas fa-cogs"></i>
                            <p>Technical training, ongoing consulting, and enablement programs</p>
                        </div>
                        <div class="feature-item slide-in" data-delay="800">
                            <i class="fas fa-users"></i>
                            <p>Seamless integration with existing infrastructure through industry partnerships</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-lg-4 col-md-6">
                <div class="animated-card slide-in" data-delay="1000" style="background: linear-gradient(135deg, #01579b, #006064);">
                    <div class="card-content">
                        <div class="card-icon">
                            <i class="fas fa-laptop-code"></i>
                        </div>
                        <h3>Device Management</h3>
                        <p>Streamline your IT operations with Apple's powerful device management solutions.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="animated-card slide-in" data-delay="1200" style="background: linear-gradient(135deg, #007bff, #0056b3);">
                    <div class="card-content">
                        <div class="card-icon">
                            <i class="fas fa-shield-alt"></i>
                        </div>
                        <h3>Security</h3>
                        <p>Protect your business with Apple's built-in security features and enterprise-grade protection.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="animated-card slide-in" data-delay="1400" style="background: linear-gradient(135deg, #ce202f, #a51c2a);">
                    <div class="card-content">
                        <div class="card-icon">
                            <i class="fas fa-users"></i>
                        </div>
                        <h3>Team Support</h3>
                        <p>Empower your team with comprehensive training and ongoing technical support.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="container mb-4">
    <div class="d-flex justify-content-end">
        <button class="btn back-btn" (click)="navigateToHome()">
            <i class="fas fa-arrow-left me-2"></i> Back to Home
        </button>
    </div>
</div>
<br>